import type { SharedExamByTokenRecord } from '@/shared/repositories/exams/sharedExamByTokenRecord'

const FIXTURE_EXAM_SHARE_TOKEN = 'FIXTURE-EXAM'

export function fixtureSharedExamByToken(token: string): SharedExamByTokenRecord | null {
  if (token.trim().toUpperCase() !== FIXTURE_EXAM_SHARE_TOKEN) return null
  return {
    shareId: 'fixture-share-id',
    examResultId: 'fixture-exam-id',
    examName: 'Hemoglobina glicada',
    examDate: '2026-04-20T10:00:00.000Z',
    value: 5.4,
    numericValue: 5.4,
    unit: '%',
    laboratory: 'Laboratório fixture',
    refMin: 4,
    refMax: 5.6,
    warningThresholdPercent: 10,
    patientName: 'Paciente F.',
    expiresAt: '2099-12-31T23:59:59.000Z',
  }
}
